const buildPerformanceChart = () => {
  const chartEl = document.getElementById("performanceChart");
  if (!chartEl || typeof window.Plotly === "undefined") {
    return;
  }

  try {
    const trace1 = {
      x: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      y: [85, 88, 82, 90, 87, 89, 91],
      type: "scatter",
      mode: "lines+markers",
      name: "Success Rate",
      line: { color: "#2173e4", width: 3 },
      marker: { size: 8, color: "#2173e4" }
    };

    const trace2 = {
      x: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      y: [45, 52, 48, 55, 50, 53, 58],
      type: "bar",
      name: "Trials Completed",
      marker: { color: "#8B5CF6" }
    };

    const data = [trace1, trace2];

    const layout = {
      title: { text: "", font: { size: 16 } },
      xaxis: { title: "Day of Week" },
      yaxis: { title: "Value" },
      margin: { t: 20, r: 20, b: 60, l: 60 },
      plot_bgcolor: "#FFFFFF",
      paper_bgcolor: "#FFFFFF",
      showlegend: true,
      legend: { x: 0, y: 1.1, orientation: "h" }
    };

    const config = { responsive: true, displayModeBar: false, displaylogo: false };

    window.Plotly.newPlot(chartEl, data, layout, config);
  } catch (error) {
    chartEl.innerHTML = '<div class="flex items-center justify-center h-full text-gray-500">Chart could not be loaded</div>';
  }
};

document.addEventListener("turbo:load", buildPerformanceChart);
